<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col>
        <mdb-btn
          @click="addNewUnionmember"
          color="primary"
          size="sm"
          >{{ $t("add_new_unionmember") }}</mdb-btn
        >
      </mdb-col>
    </mdb-row>
    <DataTableAG
      deleteparam="frontpageids"
      :columns="columns"
      width="1150px"
      height="1600px"
      archivecontentpath2="2.0/newbe/unionfrontpage/delete"
      archiveparam="id"
      :getcontentpath="getunionmemberspath"
      :buttonList="['Muokkaa', 'Poista Liitto', 'Vaihda aktiivisuus']"
      jsonobject="unionmembers"
      :image="true"
      v-on:pressed-button1="editUnionmember"
      v-on:pressed-button2="deleteUnionmember"
      v-on:pressed-button3="switchActive"
      :rowHeight="130"
    />
  </mdb-container>
</template>

<script>
import DataTableAG from "@/components/DataTableAG.vue";
import { mdbContainer, mdbRow, mdbCol, mdbBtn } from "mdbvue";

export default {
  name: "Unionmembers",
  components: {
    DataTableAG,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
  },
  methods: {
    addNewUnionmember() {
      this.$router.push("/addunionmember");
    },
    editUnionmember(rowData) {
      this.$router.push("/addunionmember/" + rowData.id);
    },
    deleteUnionmember(rowData) {
      this.$http
        .delete(
          this.deleteunionmemberpath + rowData.id
        )
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("swiching_front_page_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("swithing_front_page_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutmedium,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
    switchActive(rowData) {
      this.postData = {
        id: rowData.id,
        active: 1 - rowData.active,
      };
      this.$http
        .post(
          this.setactiveunionmemberpath,
          JSON.stringify(this.postData)
        )
        .then((response) => {
          if (response.status == 200) {
            this.$notify.success({
              message: this.$t("swiching_front_page_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
          setTimeout(() => {
            this.$router.go();
          }, 1000);
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("swithing_front_page_not_success"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutmedium,
          });
          console.log(error);
        })
        .finally(() => (this.loading = false));
    },
  },
  data: () => ({
    getunionmemberspath: "/1.0/front/unionmembers",
    setactiveunionmemberpath: "/1.0/front/unionmember/activate",
    deleteunionmemberpath: "/1.0/front/unionmember/",
    columns: [
      {
        field: "id",
        headerName: "Liitto",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "name",
        headerName: "Nimi",
        width: 250,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
      {
        field: "active",
        headerName: "Aktiivinen",
        width: 200,
        pinned: "left",
        sortable: true,
        filter: true,
        resizable: true,
      },
    ],
  }),
  mounted() {},
};
</script>